(function() {
  angular.module('forgotPassword')
  .controller('challengeUserController', ['$scope','$log','$state','loginUserService','User','$translate',
  function($scope, $log, $state,loginUserService,User,$translate) {
    var vm = this;
    vm.reset = reset;
    vm.submit = submit;
    vm.previous = previous;
    vm.model = _.pick(loginUserService.loginModel(),['userId','email','challengeResponses']);

    if (vm.model.userIdentified) {
       $state.go('confirmPasswordReset');
    }

    if (!(vm.model.challengeResponses[0] && vm.model.challengeResponses[0].challenge)) {
       $state.go('forgotPassword',{userId: vm.model.userId});
    }

    function previous(){
      $state.go('forgotPassword',{userId: vm.model.userId});
    }

    function saveModel(){
      loginUserService.loginModel(vm.model);
    }

    function clearFormErrors(){
      $scope.challengesForm.$setValidity('incorrectResponse',true);
    }

    function reset(){
      vm.accept = "";
      _.each(vm.model.challengeResponses,(challengeResponses) => {
        challengeResponses.response=undefined;
      });
      saveModel();
      $scope.errorControl.hideErrors();
    }

    function submit(){
      clearFormErrors();
      $scope.errorControl.showErrors();
      if ($scope.challengesForm.$valid) {
          vm.running = true;
          let params = _.pick(vm.model,['userId','email']);
          params.responses=_.map(vm.model.challengeResponses,"response");
          User.challengeResponses(params,function(result){
            vm.running = false;
            if (result.responsesVerified){
              vm.model.challengeResponses = [{},{},{}];
              vm.model.userIdentified = true;
              saveModel();
              $state.go('confirmPasswordReset');
            }else{
              $scope.challengesForm.$setValidity('incorrectResponse',result.responsesVerified);
            }
          },(error) => {
            vm.running = false;
            saveModel();
          });
      }
    }

  }]);
})();
